import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class GlobalProvider {
  loadingJwt = true;
  profileType: any;
  profile: any;
  role: any;
  jws: any;
  accessRole: any = {};
  mediaUrl: any;
  config: any;
  menuReady = false;
  globalSetting:any={};
  

  constructor(
    protected alertController: AlertController,
    private router: Router
  ) {}

  async showConfirmPop(
    headMsg: any,
    subMsg: any,
    okText = 'Yes',
    cancelText = 'No'
  ) {
    return new Promise(async (res) => {
      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: headMsg,
        message: subMsg,
        buttons: [
          {
            text: cancelText,
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              res(false);
              // console.log("Confirm Cancel: blah");
            },
          },
          {
            text: okText,
            handler: () => {
              res(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async customConfirmPop(
    headMsg: any,
    subMsg: any,
    okText: any,
    cancelText: any
  ) {
    return new Promise(async (res) => {
      const alert = await this.alertController.create({
        cssClass: 'customButtonConfirmation',
        header: headMsg,
        message: subMsg,
        buttons: [
          {
            text: cancelText,
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              res(false);
            },
          },
          {
            text: okText,
            handler: () => {
              res(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async showAlert(header: any, message: any) {
    return new Promise(async (res) => {
      const alert = await this.alertController.create({
        cssClass: 'additionalReqAlert',
        header,
        message,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              res(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  checkRoleAccess(page: any, right: any) {
    console.log('AccessType?', this.role);
    if (this.role == 'ADMIN') return true;
    let arr = this.accessRole.accessRoleRights.find((el: any) => {
      return (
        el.accessClassName === page && (el.key === right || el.key === 'global')
      );
    });

    if (arr) {
      return true;
    } else {
      return false;
    }
  }

  // async checkAccess(): Promise<boolean> {
  //   // 1️⃣ Get current URL (example: /gps/list?id=1)
  //   const fullUrl = this.router.url;

  //   // 2️⃣ Extract base path → /gps
  //   const basePath = '/' + fullUrl.split('?')[0].split('/')[1];

  //   console.log('Current basePath:', basePath);
  //   console.log("Current basePath:",  this.profile)

  //   // 3️⃣ If no profile loaded
  //   if (!this.profile) {
  //     console.warn('Profile not loaded');
  //     return false;
  //   }

  //   // 4️⃣ Admin has full access
  //   if (
  //     this.profile.accessType === 'admin'
  //   ) {
  //     return true;
  //   }

  //   // 5️⃣ Get access rights safely
  //   const rights =
  //     this.profile?.accessRole?.accessRoleRights || [];

  //   // 6️⃣ Check if current path exists in permissions
  //   const hasAccess = rights.some(
  //     (right: any) => right.ns === basePath
  //   );

  //   console.log('Has access:', hasAccess);

  //   return hasAccess;
  // }
  //   checkAccess(
  //   ns: string,
  //   key: 'list' | 'create' | 'edit'
  // ): boolean {
  //   if (!this.profile) return false;

  //   // Admin override
  //   if (this.profile.accessType === 'admin') return true;

  //   const role = this.profile.accessRole;

  //   // Full access
  //   if (role?.all === 1) return true;

  //   const rights = role?.accessRoleRights ?? [];

  //   return rights.some((r: any) => {
  //     if (r.ns !== ns) return false;

  //     // Exact match
  //     if (r.key === key) return true;

  //     // 🔥 manage = create + edit
  //     if (
  //       r.key === 'manage' &&
  //       (key === 'create' || key === 'edit')
  //     ) {
  //       return true;
  //     }

  //     return false;
  //   });
  // }
  checkAccess(ns: string, key: 'list' | 'create' | 'edit' | 'topup'): boolean {
    if (!this.profile) return false;
   
    if(!this?.profile?.accessRole){
      //console.log("status?", this?.profile?.accessRole)
    }
    // Admin override
    if (this.profile.accessType === 'admin') return true;
    if (this?.profile?.accessType === 'merchant' && !this?.profile?.accessRole &&  this?.profile?.role === 'admin' || this?.profile?.role === 'staff') return true;
    const role = this.profile.accessRole;

    // Full access
    if (role?.all === 1) return true;

    const rights = role?.accessRoleRights ?? [];

    return rights.some((r: any) => {
      if (r.ns !== ns) return false;

      // Exact match
      if (r.key === key) return true;

      // manage ⇒ create + edit
      if (r.key === 'manage' && (key === 'create' || key === 'edit')) {
        return true;
      }

      return false;
    });
  }

  hasAnyAccess(ns: string): boolean {
    if (!this.profile) return false;

    // Admin sees everything
    if (this.profile.accessType === 'admin') return true;

    if (this?.profile?.accessType === 'merchant' &&  this?.profile?.role === 'admin' || this?.profile?.role === 'staff' && !this?.profile?.accessRole) return true;

    const role = this.profile.accessRole;

    // Full access role
    if (role?.all === 1) return true;

    const rights = role?.accessRoleRights ?? [];

    return rights.some((r: any) => r.ns === ns);
  }
}
